import React from "react";
import { Table, Empty } from "antd";

const formatAmount = (value) => {
  const num = parseFloat(value);
  return Number.isNaN(num)
    ? "-"
    : `$${num.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
};

const formatVolume = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return /L$/i.test(String(value).trim()) ? value : `${value} L`;
};

const normalise = (txn, index) => {
  const vehicleParts = [txn.vehicle_id, txn.vehicle_name].filter(Boolean);
  return {
    key: txn.id ?? txn.txnId ?? txn.txn_id ?? index,
    txnId: txn.txnId ?? txn.txn_id ?? "-",
    date: [txn.date, txn.time].filter(Boolean).join(" ") || "-",
    vehicle:
      txn.vehicle ?? (vehicleParts.length ? vehicleParts.join(" · ") : "-"),
    driver: txn.driver ?? txn.driver_name ?? "-",
    fuelType: txn.fuelType ?? txn.fuel_type_name ?? "-",
    volume: formatVolume(txn.volume),
    amount: txn.amount,
  };
};

const columns = [
  { title: "Txn Id", dataIndex: "txnId", key: "txnId" },
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Vehicle", dataIndex: "vehicle", key: "vehicle" },
  { title: "Driver", dataIndex: "driver", key: "driver" },
  { title: "Fuel Type", dataIndex: "fuelType", key: "fuelType" },
  { title: "Volume", dataIndex: "volume", key: "volume" },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: formatAmount,
  },
];

const SettlementTransactionsTable = ({ transactions = [] }) => (
  <Table
    size="small"
    columns={columns}
    dataSource={transactions.map(normalise)}
    pagination={false}
    scroll={{ x: "max-content" }}
    locale={{
      emptyText: (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No transactions linked to this payment"
        />
      ),
    }}
  />
);

export default SettlementTransactionsTable;
